// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multiline-editor[data-v-2090b537] {\n    white-space: pre !important;\n}\n", ""]);
// Exports
module.exports = exports;
